import { useMemo } from "react";
import useGlobalContext from "./useGlobalContext";
import { BOX_TYPES, PATHS_WHITELIST, HOME_PATHS, PATHS_ERROR_WHITELIST } from "../constants";

const useCheckPaths = () => {
  const { selectedBox, selectedAsset, getSessionDataByKey } = useGlobalContext();

  const getDefaultPathByBox = (box) => {
    if (box && box.subtype === BOX_TYPES.EMISOR)
      return HOME_PATHS.EMISOR;
    return HOME_PATHS.DEFAULT;
  };

  const defaultPath = useMemo(() => {
    return getDefaultPathByBox(selectedBox);
  }, [selectedBox]);

  const pathWhitelist = useMemo(() => {
    const selectedAssetMenu = getSessionDataByKey("models")?.[selectedAsset.id]?.menu;
    const actualPathWhitelist = selectedAssetMenu?.reduce((acc, item) => {
      if (item.path && (!item.permissions || item.permissions.includes(Number(selectedBox.subtype))))
        acc.push(item.path);
      return acc;
    }, []).concat(PATHS_WHITELIST, PATHS_ERROR_WHITELIST);    

    if (!actualPathWhitelist || actualPathWhitelist.length === 0) {
      return PATHS_WHITELIST.concat(PATHS_ERROR_WHITELIST);
    }    

    return actualPathWhitelist;
  }, [selectedAsset, selectedBox]);

  return {
    defaultPath,
    pathWhitelist,
    getDefaultPathByBox,
  }
}

export default useCheckPaths;